import { ICalendar, RecurringFrequency, WeekDay } from '../models/api/Calendar'
import BaseService from './BaseService'
interface GetItemsByLocationId {
  locationId: string
}

interface RRule {
  freq: RecurringFrequency
  count: number
  interval?: number
  weekDays?: WeekDay[]
  monthDays?: number[]
}

interface ValidateCalendarSlugBody {
  groupId: string
  slug: string
  calendarId?: string
}

type GetCalendarEventsParams = {
  filter: {
    locationId: string
    userId?: string
    contactId?: string
    calendarId?: string
    groupId?: string
    startTime: string
    endTime: string
  },
  sort?: {
    field: 'dateAdded' | 'startTime'
    direction: 'asc' | 'desc'
  },
  includeAll?: boolean
}

type GetAppointmentsParams = {
  filter: {
    locationId: string
    userId?: string
    contactId?: string
    calendarId?: string
    groupId?: string
    appointmentStatus?: string
  },
  sort?: {
    field: 'dateAdded' | 'startTime'
    direction: 'asc' | 'desc'
  },
  startAfter?: string
  limit?: number
}

class CalendarService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }
  getTeams = (params: GetItemsByLocationId) => this.requests.get('/teams', { params })
  getCalendars = (params: GetItemsByLocationId) => this.requests.get('/', { params })
  getIntegratedCalendars = (params: { locationId?: string; userId?: string; source: 'GOOGLE' | 'OUTLOOK' }) =>
    this.requests.get('/external-calendars/get-calendars', { params })
  getCalendarEvents = (params: GetCalendarEventsParams) => this.requests.post('/events/get-calendar-events', params)
  getAppointments = (params: GetAppointmentsParams) => this.requests.post('/events/get-appointments', params)
  create = (body: ICalendar) => this.requests.post('/', body)
  read = (id: string) => this.requests.get(`/${id}`)
  update = (id: string, body: Partial<ICalendar>) => this.requests.put(`/${id}`, body)
  isValidCalendarSlug = (body: ValidateCalendarSlugBody) => this.requests.post('/validate-calendar-slug', body)
  generateRRuleText = (body: RRule) => this.requests.post('/generate-rrule-text', body)
  fetchAppointment = eventId => this.requests.get(`/events/appointments/${eventId}`)
  deleteAppointment = eventId => this.requests.delete(`/events/appointments/${eventId}`)
  updateAppointment = (appointmentId: string, appointment: any) =>
    this.requests.put(`/events/appointments/${appointmentId}`, appointment)
  updateBlockSlot = (appointmentId: string, appointment: any) =>
    this.requests.put(`/events/block-slots/${appointmentId}`, appointment)
  getSubAccountConfig = (locationId: string) => this.requests.get(`/configuration/location/${locationId}`)
  updateSubAccountConfig = (locationId: string, body: any) =>
    this.requests.put(`/configuration/location/${locationId}`, body)
  getAllServices = (locationId: string) => this.requests.get(`/services?locationId=${locationId}`)
  getUserTimezonePreference = (locationId: string, userId: string) =>
    this.requests.get(
      `/user-settings/${locationId}/${userId}/features`
    )
}

const instance = new CalendarService(BaseService.servicesConfig.Calendar)

export default instance
